import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["expandable"]
  static classes = ["hidden"]

  toggle(event) {
    console.debug("[ToggleWithCheckbox] toggle")

    const checkbox = event.currentTarget
    if (checkbox.checked) {
      this.open(checkbox)
    } else {
      this.#close(checkbox)
    }
  }

  open(checkbox) {
    this.expandableTarget.classList.remove(this.hiddenClass)
    checkbox.ariaExpanded = true
  }

  #close(checkbox) {
    this.expandableTarget.classList.add(this.hiddenClass)
    checkbox.ariaExpanded = false
  }
}
